<template>
  <modal
    class="result-text-modal modal-without-footer"
    name="result-text-modal"
    @closed="$emit('updateComparisonData')"
    @before-open="beforeOpen"
    transition="fade"
    :adaptive="true"
    :scrollable="true"
    :reset="true"
    width="60%"
    height="90%"
  >
    <div id="modal-header" class="action-modal">
      <div class="w-75 d-flex">
          <p>Ընթացակարգի արդյունքներ</p>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 25%"
              @click="$modal.hide('result-text-modal')"
              aria-label="Close"
      >
          <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 1.64102L14.859 0L8.49997 6.359L2.14102 4.62582e-05L0.5 1.64107L6.85895 8.00002L0.500034 14.3589L2.14105 16L8.49997 9.64104L14.8589 16L16.5 14.359L10.141 8.00002L16.5 1.64102Z" fill="#ABAEB8"/>
          </svg>
      </button>
    </div>
    <div id="modal-body">
      <div v-if="loading" class="h-100 d-flex align-items-center justify-content-center">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only"></span>
        </div>
      </div>
      <div v-else>
        <div v-if="getWonCpvNamesString().length" style="background-color: #f0fdf4; border: 1px solid #bbf7d0; border-left: 4px solid #16a34a; border-radius: 6px; padding: 16px; color: #166534;">
          <div style="display: flex; align-items: center; gap: 8px; font-weight: 600; font-size: 15px; margin-bottom: 8px;">
            <span>🎉</span>
            <span>Մրցույթի արդյունքների ծանուցում</span>
          </div>

          <p style="margin: 0 0 8px 0;">
            Տեղեկացնում ենք, որ Դուք մասնակցել եք այս մրցույթին և հաղթող եք ճանաչվել հետևյալ չափաբաժինների մասով՝
          </p>

          <div style="background-color: #ffffff; border: 1px solid #dcfce7; border-radius: 4px; padding: 8px 12px; margin: 8px 0; font-weight: 600; color: #15803d;">
            Չափաբաժիններ՝ <span v-html="getWonCpvNamesString()"></span>
          </div>

          <p style="margin: 8px 0 4px 0; color: #4b5563; font-size: 13px;">
            Մյուս չափաբաժինների մասով Ձեր առաջարկը հաղթող չի ճանաչվել։
          </p>

          <p style="margin: 8px 0 0 0; font-size: 13px; color: #374151;">
            Շնորհակալություն մասնակցության համար։
          </p>
        </div>

        <!-- Loss / Neutral Notification -->
        <div v-else style="border: 1px solid #E11D48; border-left: 4px solid #E11D48; border-radius: 6px; padding: 16px; color: #334155;">
          <div style="display: flex; align-items: center; gap: 8px; font-weight: 600; font-size: 15px; margin-bottom: 8px; color: #BE123C;">
            <span>📢</span>
            <span>Մրցույթի արդյունքների վերաբերյալ ծանուցում</span>
          </div>

          <p style="margin: 0 0 8px 0;">
            Տեղեկացնում ենք, որ Դուք մասնակցել եք այս մրցույթին, սակայն ներկայացված առաջարկների գնահատման արդյունքում հաղթող չեք ճանաչվել։
          </p>

          <p style="margin: 0; font-size: 13px; color: #64748b;">
            Շնորհակալություն մասնակցության համար։
          </p>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
export default {
  name: 'ResultTextModal',
  data() {
    return {
      loading: false,
      data: false,
      winData: false,
    }
  },
  computed: {
    me() {
      return this.$store.getters['user/me']
    },
  },
  methods: {
    async beforeOpen({params}) {
      this.loading = true
      const response = await this.$client.get(`/suggestions/view/${params.id}`);
      this.data = response.data.data;
      this.winData = this.data.organize.winners.filter(w => w.user_id === this.me.id);
      this.loading = false;
    },
    getWonCpvNamesString() {
      if (!this.winData?.length) return '';

      return this.winData
        .flatMap(winner => winner.won_lots || [])
        .map(lot => lot?.procurement_plan?.cpv?.name)
        .filter(Boolean) // Filter first so numeration indices remain sequential
        .map((cpvName, index) => `<br> #${index + 1} ${cpvName} `)
        .join(', ');
    }
  }
}
</script>
